import Camera2Icon from '@amazd/common/icons/Camera2Icon';
import { CompanyImageUploadPurposeEnum } from 'hooks/useCompanyImageUpload';
import usePopup from 'hooks/usePopup';

import useStyles from './styles';
import UploadModal from './UploadModal';

export interface Props {
  companyId: string;
  purpose?: CompanyImageUploadPurposeEnum;
  value?: string;
  onChange?: (value: string) => void;
  onRemove?: () => void;
  defaultValue: string;
}

const AvatarPicker = ({ companyId, purpose, defaultValue, value, onChange, onRemove }: Props) => {
  const styles = useStyles();
  const { isOpen, openPopup, closePopup } = usePopup();

  const handleChange = (value: string) => {
    onChange?.(value);
    closePopup();
  };

  const handleRemove = () => {
    onRemove?.();
    closePopup();
  };

  return (
    <>
      <div className={styles.root} style={{ backgroundImage: `url(${value || defaultValue})` }} onClick={openPopup}>
        <span>
          <Camera2Icon className={styles.hoverIcon} />
        </span>
      </div>
      <UploadModal
        isRemovable={!!value}
        open={isOpen}
        onClose={closePopup}
        companyId={companyId}
        purpose={purpose}
        onChange={handleChange}
        onRemove={handleRemove}
      />
    </>
  );
};

AvatarPicker.displayName = 'AvatarPicker';

export default AvatarPicker;
